import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "./main.css";
import PageTitle from "../pagetitle/PageTitle";

//Import Pages
import ProtectedRouter from "./ProtectedRouter";
import Dashboard from "../dashboard/Dashboard";
import Customer from "../masters/customer/Customer";
import Gender from "../masters/gender/Gender";
import Item from "../masters/item/Item";
import UoM from "../masters/uom/UoM";
import Collection from "../transactions/collection/Collection";
import Sales from "../transactions/sales/Sales";
import SalesEdit from "../transactions/sales/SalesEdit";
import SalesReport from "../report/sales/SalesReport";
import CollectionReport from "../report/collection/CollectionReport";
import SummaryReport from "../report/summary/SummaryReport";

//Import Context
import { SalesProvider } from "../transactions/sales/SalesContext";

const Main = () => {
  const [pageTitle, setPageTitle] = useState("");
  const location = useLocation();

  const routeToPageTitle = {
    "/dashboard": "Dashboard",
    "/category": "Category",
    "/customer": "Customer",
    "/customertype": "Customer Type",
    "/gender": "Gender",
    "/item": "Item",
    "/uom": "UoM",
    "/collection": "Collecion",
    "/sales": "Sales",
    "/salesedit": "Sales Edit",
    "/collectionreport": "Collection Report",
    "/salesreport": "Sales Report",
    "/summaryreport": "Summary Report",
  };

  useEffect(() => {
    const currentPath = location.pathname;
    setPageTitle(routeToPageTitle[currentPath] || { pageTitle });
  }, [location.pathname]);

  return (
    <main id="main" className="main">
      <PageTitle page={pageTitle} />
      <SalesProvider>
        <Routes>
          <Route
            path="/dashboard"
            element={
              <ProtectedRouter>
                <Dashboard />
              </ProtectedRouter>
            }
          />
          <Route
            path="/customer"
            element={
              <ProtectedRouter>
                <Customer />
              </ProtectedRouter>
            }
          />
          <Route
            path="/gender"
            element={
              <ProtectedRouter>
                <Gender />
              </ProtectedRouter>
            }
          />
          <Route
            path="/item"
            element={
              <ProtectedRouter>
                <Item />
              </ProtectedRouter>
            }
          />
          <Route
            path="/uom"
            element={
              <ProtectedRouter>
                <UoM />
              </ProtectedRouter>
            }
          />
          <Route
            path="/collection"
            element={
              <ProtectedRouter>
                <Collection />
              </ProtectedRouter>
            }
          />
          <Route
            path="/sales"
            element={
              <ProtectedRouter>
                <Sales />
              </ProtectedRouter>
            }
          />
          <Route
            path="/salesedit"
            element={
              <ProtectedRouter>
                <SalesEdit />
              </ProtectedRouter>
            }
          />
          <Route
            path="/salesreport"
            element={
              <ProtectedRouter>
                <SalesReport />
              </ProtectedRouter>
            }
          />
          <Route
            path="/collectionreport"
            element={
              <ProtectedRouter>
                <CollectionReport />
              </ProtectedRouter>
            }
          />
          <Route
            path="/summaryreport"
            element={
              <ProtectedRouter>
                <SummaryReport />
              </ProtectedRouter>
            }
          />
        </Routes>
      </SalesProvider>
    </main>
  );
};

export default Main;
